<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'编辑会员':'新建会员'" :visible.sync="dialog" @close="unShowClick()" width="30%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="用户名称" prop="name" :label-width="formLabelWidth">
					<el-select style="width: 100%;" v-model="addBody.name" :disabled='isEdit' filterable remote
						reserve-keyword @change="changeName" placeholder="请输入用户名称" :remote-method="remoteMethod"
						:loading="loading">
						<el-option v-for="item in userList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户ID" :label-width="formLabelWidth">
					<el-input style="width: 100%;" disabled v-model="addBody.member_uuid"
						placeholder="请输入用户ID"></el-input>
				</el-form-item>
				<el-form-item label="会员等级" prop="level" :label-width="formLabelWidth">
					<el-select style="width: 100%;" v-model="addBody.level" @change="changeLevel" placeholder="请选择会员等级">
						<el-option v-for="item in level" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="到期时间" prop="member_time" :label-width="formLabelWidth">
					<el-date-picker style="width: 100%;" format='yyyy-MM-dd' value-format='yyyy-MM-dd'
						v-model="addBody.member_time" type="date" placeholder="请选择到期时间">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getMemberList,
		getUserList,
		addUserMember,
		editUser,
		getUser
	} from '@/api/user'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				loading: false,
				level: [],
				userList: [],
				activeName: 'zh',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					member_uuid: '',
					name: '',
					phone: "",
					member_time: "",
					uuid: '',
					level: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					level: [{
						required: true,
						message: '请选择等级',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请选择用户',
						trigger: 'blur'
					}, ],
					member_time: [{
						required: true,
						message: '请选择到期时间',
						trigger: 'blur'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				currentUser: ''
			}
		},
		mounted() {
			this.getMemberList()
		},
		methods: {
			changeLevel(e) {
				this.addBody.level = e
			},
			changeName(e) {
				this.addBody.member_uuid = e
				let itemUser = this.userList.find(item => {
					return item.uuid == e
				})
				if (itemUser) {
					this.addBody.member_time = itemUser.member_time
					this.addBody.level = itemUser.member_uuid
				}
			},
			async remoteMethod(query) {
				if (query !== '') {
					this.loading = true;
					let postData = {
						page_size: 99,
						page_index: 1,
						name: query,
					};
					const {
						status,
						data
					} = await getUserList(postData);
					if (status !== 200) return;
					this.userList = data.result.data;
					this.loading = false
				} else {
					this.userList = [];
				}
			},
			async getMemberList() {
				const {
					data
				} = await getMemberList({
					page_index: 1,
					page_size: 999
				});
				this.level = data.result.data
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editUser()
						} else {
							this.network().addUserMember()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.addBody.member_time = ''
				this.addBody.member_uuid = ''
				this.addBody.name = ''
				this.$emit('input', false)
			},
			network() {
				return {
					addUserMember: async () => {
						const {
							status,
							data
						} = await addUserMember({
							member_uuid: this.addBody.level,
							user_uuid: this.addBody.member_uuid,
							member_time: this.addBody.member_time
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					editUser: async () => {
						const {
							status
						} = await addUserMember({
							member_uuid: this.addBody.level,
							user_uuid: this.addBody.uuid,
							member_time: this.addBody.member_time
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getUser: async (uuid) => {
						const {
							data,
							status
						} = await getUser({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.addBody.level = val.member_uuid
					this.addBody.member_uuid = val.member_uuid
					this.addBody.name = val.name
					this.addBody.phone = val.phone
					this.addBody.member_time = val.member_time
					this.addBody.uuid = val.uuid
				} else {
					this.isEdit = false
					this.addBody.level = ''
					this.addBody.member_uuid = ''
					this.addBody.name = ''
					this.addBody.phone = ''
					this.addBody.member_time = ''
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>